<template>
    <div v-if="isOpen" class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
        <div class="bg-white rounded-lg p-8 shadow-lg w-full max-w-md">
            <div class="flex justify-between items-center mb-4">
                <h2 class="text-2xl font-semibold text-gray-800">Privacy Policy</h2>
                 <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700 focus:outline-none">
                    <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div class="mb-4">
                 <p class="text-gray-700">
                    We collect the personal information that you provide us directly to manage your application process.
                     This includes your name, contact details (email, phone), and the content of your CV. This information
                     will only be used to consider you for the specific job you have applied to and may be shared with
                     internal teams in charge of evaluating applications.
                   </p>

                  <p class="text-gray-700 mt-2">
                     We ensure the protection of your data and do not share it with external parties. The application
                      process is made secure through our platforms and third-party services, which we thoroughly vet
                    to ensure compliance with data protection standards.
                </p>
                 <p class="text-gray-700 mt-2">
                     You have the right to access, correct, or delete your personal data at any time. If you have any questions
                    or wish to exercise these rights, please contact us through our established channels.
                   </p>
                  <p class="text-gray-700 mt-2">
                       By applying, you acknowledge that you have read and understood our privacy policy.
                     </p>
            </div>
         </div>
    </div>
 </template>

 <script>
 export default {
     props: {
         isOpen: {
            type: Boolean,
              default: false,
          }
     }
 };
 </script>